import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../../app/api/api';
import MealItem from '../../../app/data/models/mealItem';

interface KitchenMealItemsState {
  kitchenMealItems: MealItem[];
  status: string;
}

const initialState: KitchenMealItemsState = {
  kitchenMealItems: [],
  status: 'idle',
};

export const fetchKitchenMealItemsAsync = createAsyncThunk<
  MealItem[],
  { restaurantId: string; kitchenId: string }
>(
  'kitchenMealItems/fetchKitchenMealItemsAsync',
  async ({ restaurantId, kitchenId }) => {
    const mealItems = await api.Kitchen.getMealItems(restaurantId, kitchenId);
    return mealItems;
  }
);

export const kitchenMealItemsSlice = createSlice({
  name: 'kitchenMealItems',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchKitchenMealItemsAsync.pending, (state) => {
      state.status = 'pendingFetchKitchenMealItems';
    });
    builder.addCase(fetchKitchenMealItemsAsync.fulfilled, (state, action) => {
      state.kitchenMealItems = action.payload;
      state.status = 'idle';
    });
    builder.addCase(fetchKitchenMealItemsAsync.rejected, (state) => {
      state.status = 'idle';
    });
  },
});

export default kitchenMealItemsSlice.reducer;
